export default {
  SET_LINKS: (state, payload) => {
    state.links = payload;
  },
  SET_FORM_BUILDERS: (state, payload) => {
    state.formBuilders = payload;
  },
  SET_FORM_BUILDERS_PAGINATION: (state, payload) => {
    state.formBuildersPagination = payload;
  },
  SET_FORM_BUILDERS_LOADING: (state, payload) => {
    state.formBuildersLoading = payload;
  },
  SET_TEMPLATES: (state, payload) => {
    state.templates = payload;
  },
  SET_TEMPLATES_PAGINATION: (state, payload) => {
    state.templatesPagination = payload;
  },
  SET_TEMPLATES_LOADING: (state, payload) => {
    state.templatesLoading = payload;
  },
  SET_FORM_FLOW: (state, payload) => {
    state.formFlow = payload;
  },
  SET_LIST_VARIABLES: (state, payload) => {
    state.listVariables = payload;
  },
  SET_ENABLED: (state, payload) => {
    state.formFlow.enabled = !!payload;
  },
  SET_SIGNER_LINKS: (state, payload) => {
    state.signerLinks = payload;
  },
  SET_SIGNERS_LIST: (state, payload) => {
    state.signersList = payload;
  },
  SET_RUBRICATES: (state, payload) => {
    state.rubricates = payload;
  },
  SET_SIGNATURE_WATCHERS: (state, payload) => {
    state.signatureWatchers = payload;
  },
  SET_MAPPINGS: (state, payload) => {
    state.mappings = payload;
  },
  SET_GENERATED_VARIABLES: (state, payload) => {
    state.generatedVariables = payload;
  },
  DELETE_GENERATED_VARIABLES(state, itemId) {
    state.generatedVariables = state.generatedVariables.filter((item) => item.id !== itemId);
  },
  UPDATE_SUGGEST_VARIABLE_NAME(state, { id, value }) {
    const variable = state.generatedVariables.find((item) => item.id === id);
    if (variable) {
      variable.suggestVariableName = value;
    }
  },
  ADD_SUGGEST_VARIABLE_NAME: (state, payload) => {
    state.generatedVariables.push(payload);
  },
};
